exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".modal-header[data-v-522f1b25] {\n  align-items: center;\n}\n", "", {"version":3,"sources":["/home/vsts/work/1/s/apps/client/common/src/components/Modal.vue"],"names":[],"mappings":"AACA;EACI,oBAAmB;CAAA","file":"Modal.vue?vue&type=style&index=0&id=522f1b25&scoped=true&lang=css&","sourcesContent":["\n.modal-header {\n    align-items: center;\n}\n"],"sourceRoot":""}]);

// exports
